import React, { useEffect, useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
// import CssBaseline from '@mui/material/CssBaseline';
// import AppBarWithMenu from '../../components/appbarwithmenu';
import { Grid, Box, Typography, Button } from '@mui/material';
import Footer from '../../components/footer';
import appTheme from '../../components/apptheme';
import Summary from './summary';
import { useSelector } from 'react-redux';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import * as caseActions from '../../actions/caseActions';
import { useDispatch } from 'react-redux';
import { ReactComponent as HeartLogo } from '../../images/Logo-Rebekah.svg';
import { useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import BadgeIcon from '@mui/icons-material/Badge';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import Pageview from '@mui/icons-material/Pageview';
import DriveFolderUploadRounded from '@mui/icons-material/DriveFolderUploadRounded';
import * as logoutAction from '../../actions/logoutAction';
import { ReactComponent as BCHLogoSOP } from '../../images/BCH-logo-SOP.svg';
import Divider from '@mui/material/Divider';
/* Stepper */
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Stack, StepContent } from '@mui/material';
import styles from './dashboardstyles';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import * as Status from '../../config/status';
import GetStarted from './getstarted/getstarted';
import ContactInfo from './contactinfo/contactinfo';
import ReferringMD from './referringmdinfo/referringmd';
import AdditionalInfo from './additionalinfo/additionalinfo';
import GuardianInfo from './guardianinfo/guardianinfo';
import InsuranceInfo from './insuranceinfo/insuranceinfo';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import { useSnackbar } from 'notistack';
// import * as Constants from '../../config/constants';
import * as loginActions from '../../actions/loginActions';
//import UploadFileIcon from '@mui/icons-material/UploadFile';
import { DropzoneDialog } from 'mui-file-dropzone';
import FileUpload from './fileupload/fileupload';
import { FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
const steps = [
  "Let's get started",
  'Case created',
  'Tell us more',
  'Case has been assigned to a coordinator',
  'Collect records',
  'Under review by MD',
  'Review expert opinion',
  'Pending your arrival',
  'Welcome to BCH!'
];
export default function Dashboard() {
  console.log('Dashboard: - Dashboard page loading...');
  const st = useSelector((state) => state.rootReducer);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentcaseId, setCurrentcaseId] = useState(
    st.cases !== null && st.cases.length > 0 ? st.cases[0].caseId : ''
  );
  const [currentcase, setCurrentcase] = useState(
    st.cases !== null && st.cases.length > 0 ? st.cases[0] : null
  );
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  // const [summary, setSummary] = React.useState(true);
  const [basicInfo, setBasicInfo] = React.useState(false);
  const [contactInfo, setContactInfo] = React.useState(false);
  const [referringmdInfo, setReferringmdInfo] = React.useState(false);
  const [additionalInfo, setAdditonalInfo] = React.useState(false);
  const [guardianInfo, setGuardianInfo] = React.useState(false);
  const [insuranceInfo, setInsuranceInfo] = React.useState(false);
  const [uploadInfo, setUploadInfo] = React.useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [openFileUpload, setOpenFileUpload] = React.useState(false);
  const [selection, setSelection] = useState('0');
  // const firstUpdate = useRef(true);
  // const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    console.log('Case id = ', st.caseId);
    if (st.caseId !== 0) {
      setCurrentcaseId(st.caseId);
    } else return;
    if (st.caseId !== null && st.cases !== undefined && st.cases.length > 0) {
      st.cases.find((c) => {
        // string to int compare
        if (c.caseId == st.caseId) {
          setCurrentcase(c);
          dispatch(caseActions.requestGetCaseById(c));
          return;
        }
      });
    }
    if (
      st.viewSummary ||
      (basicInfo === false &&
        contactInfo === false &&
        referringmdInfo === false &&
        additionalInfo === false &&
        guardianInfo === false &&
        insuranceInfo === false &&
        uploadInfo === false)
    )
      setSummaryView();
  }, [st.caseId, st.cases, st.viewSummary]);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleSelectionChange = (event) => {
    setSelection(event.target.value);
  };
  const handleViewCasesNavMenu = () => {
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      setSummaryView();
      navigate('/sop2web/home');
    }
    // reset error when navigate out
    if (
      st.updatebasicerror !== '' ||
      st.updatecontacterror !== '' ||
      st.updatemderror !== '' ||
      st.updatebcherror !== ''
    )
      dispatch(loginActions.clearError());
  };

  const handleNewCaseNavMenu = () => {
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      dispatch(caseActions.clearCase());
      dispatch(caseActions.setShowWelcome(false));
      navigate('/sop2web/newcase');
    }
    // reset error when navigate out
    if (
      st.updatebasicerror !== '' ||
      st.updatecontacterror !== '' ||
      st.updatemderror !== '' ||
      st.updatebcherror !== ''
    )
      dispatch(loginActions.clearError());
  };
  const handleProfileNavMenu = () => {
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      navigate('/sop2web/profile');
    }
    // reset error when navigate out
    if (
      st.updatebasicerror !== '' ||
      st.updatecontacterror !== '' ||
      st.updatemderror !== '' ||
      st.updatebcherror !== ''
    )
      dispatch(loginActions.clearError());
  };

  const handleLogoutNavMenu = () => {
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      dispatch(logoutAction.logOut());
      navigate('/sop2web/signin');
    }
  };

  const handleRequestViewNavMenu = () => {
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      dispatch(caseActions.clearCase());
      navigate('/sop2web/requestview');
    }
  };

  const handleCaseChange = (event) => {
    console.log(event.target.value);
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      dispatch(caseActions.setCaseId(event.target.value));
      if (event.target.value != null && st.cases !== undefined && st.cases.length > 0) {
        var acase = null;
        st.cases.find((c) => {
          if (c.caseId == event.target.value) {
            acase = c;
            return;
          }
        });
        dispatch(caseActions.requestGetCaseById(acase));
        // location.reload();
      }
    }
  };
  const getStepIndex = () => {
    if (currentcase == null) return 0;
    switch (currentcase.status) {
      case Status.STATUS_UNKNOWN:
        return 0;
      case Status.STATUS_NEW_UNASSIGNED:
        return 2;
      case Status.STATUS_NEW_ASSIGNED:
        return 4;
      case Status.STATUS_WAIT_FOR_RECORDS:
        return 4;
      case Status.STATUS_UNDER_REVIEW_BY_MD:
        return 5;
      case Status.STATUS_PENDING_FAMILY_APPROVAL:
        return 6;
      case Status.STATUS_FINANCE_REVIEW:
      case Status.STATUS_SCHEDULING:
      case Status.STATUS_PENDING_ARRIVAL:
        return 7;
      case Status.STATUS_ARRIVED:
      case Status.STATUS_CLOSED:
        return 9;
    }
  };
  const getStatusTitle = () => {
    if (currentcase == null) return 0;
    switch (currentcase.status) {
      case Status.STATUS_UNKNOWN:
        return 0;
      case Status.STATUS_NEW_UNASSIGNED:
        return 'Pending Assignment';
      case Status.STATUS_NEW_ASSIGNED:
        return 'Pending your records';
      case Status.STATUS_WAIT_FOR_RECORDS:
        return 'Pending your records';
      case Status.STATUS_UNDER_REVIEW_BY_MD:
        return 'Under Review';
      case Status.STATUS_PENDING_FAMILY_APPROVAL:
        return 'Pending your approval';
      case Status.STATUS_FINANCE_REVIEW:
      case Status.STATUS_SCHEDULING:
      case Status.STATUS_PENDING_ARRIVAL:
        return 'Pending your arrival';
      case Status.STATUS_ARRIVED:
      case Status.STATUS_CLOSED:
        return 'Complete';
    }
  };
  const getStatusText = () => {
    if (currentcase == null) return 0;
    switch (currentcase.status) {
      case Status.STATUS_UNKNOWN:
        return 0;
      case Status.STATUS_NEW_UNASSIGNED:
        return 'Your case has been submitted and is pending assignment of a case coordinator.';
      case Status.STATUS_NEW_ASSIGNED:
        return 'Your case has been assigned and is pending on records or your response.';
      case Status.STATUS_WAIT_FOR_RECORDS:
        return 'Your case has been assigned and is pending on records or your response.';
      case Status.STATUS_UNDER_REVIEW_BY_MD:
        return 'Your case has collected medical records and is under review by MD.';
      case Status.STATUS_PENDING_FAMILY_APPROVAL:
        return 'Your case has completed review by MD and is pending our approval.';
      case Status.STATUS_FINANCE_REVIEW:
      case Status.STATUS_SCHEDULING:
      case Status.STATUS_PENDING_ARRIVAL:
        return 'Your case has completed review and is pending your arrival.';
      case Status.STATUS_ARRIVED:
      case Status.STATUS_CLOSED:
        return 'Your case has completed. Thank you.';
    }
  };
  const setSummaryView = () => {
    dispatch(caseActions.setViewSummary(true));
    setBasicInfo(false);
    setContactInfo(false);
    setReferringmdInfo(false);
    setAdditonalInfo(false);
    setGuardianInfo(false);
    setInsuranceInfo(false);
    setUploadInfo(false);
  };
  const handleGetStarted = () => {
    // navigate('/getstarted/' + st.caseId);
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      dispatch(caseActions.setViewSummary(false));
      setBasicInfo(true);
      setContactInfo(false);
      setReferringmdInfo(false);
      setAdditonalInfo(false);
      setGuardianInfo(false);
      setInsuranceInfo(false);
      setUploadInfo(false);
    }
  };
  const handleContact = () => {
    // navigate('/contactinfo/' + st.caseId);
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      dispatch(caseActions.setViewSummary(false));
      setBasicInfo(false);
      setContactInfo(true);
      setReferringmdInfo(false);
      setAdditonalInfo(false);
      setGuardianInfo(false);
      setInsuranceInfo(false);
      setUploadInfo(false);
    }
  };
  const handleReferMD = () => {
    // navigate('/referringmd/' + st.caseId);
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      dispatch(caseActions.setViewSummary(false));
      setBasicInfo(false);
      setContactInfo(false);
      setReferringmdInfo(true);
      setAdditonalInfo(false);
      setGuardianInfo(false);
      setInsuranceInfo(false);
      setUploadInfo(false);
    }
  };
  const handleAdditionalInfo = () => {
    // navigate('/additionalinfo/' + st.caseId);
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      dispatch(caseActions.setViewSummary(false));
      setBasicInfo(false);
      setContactInfo(false);
      setReferringmdInfo(false);
      setAdditonalInfo(true);
      setGuardianInfo(false);
      setInsuranceInfo(false);
      setUploadInfo(false);
    }
  };

  const handleGuardianInfo = () => {
    // navigate('/additionalinfo/' + st.caseId);
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      dispatch(caseActions.setViewSummary(false));
      setBasicInfo(false);
      setContactInfo(false);
      setReferringmdInfo(false);
      setAdditonalInfo(false);
      setGuardianInfo(true);
      setInsuranceInfo(false);
      setUploadInfo(false);
    }
  };
  /*
  const handleInsuranceInfo = () => {
    // navigate('/additionalinfo/' + st.caseId);
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      dispatch(caseActions.setViewSummary(false));
      setBasicInfo(false);
      setContactInfo(false);
      setReferringmdInfo(false);
      setAdditonalInfo(false);
      setGuardianInfo(false);
      setInsuranceInfo(true);
      setUploadInfo(false);
    }
  };*/
  /*
  const handleUploadInfo = () => {
    // navigate('/additionalinfo/' + st.caseId);
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      dispatch(caseActions.setViewSummary(false));
      setBasicInfo(false);
      setContactInfo(false);
      setReferringmdInfo(false);
      setAdditonalInfo(false);
      setGuardianInfo(false);
      setInsuranceInfo(false);
      setUploadInfo(true);
    }
  };*/
  const handleCancel = (event, reason) => {
    if (reason && reason == 'backdropClick') return;
    setShowDialog(false);
    //reset change flag
    dispatch(caseActions.setDataUpdated(false));
  };

  return (
    <ThemeProvider theme={appTheme}>
      <AppBar position="static" style={{ background: '#003087', height: 80 }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ mr: 2, display: { xs: 'none', md: 'none', lg: 'flex' } }}>
              <BCHLogoSOP />
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', lg: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit">
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left'
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'block', lg: 'none' }
                }}>
                <MenuItem key="View My Cases" onClick={handleViewCasesNavMenu}>
                  <BadgeIcon style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                  <Typography textAlign="center">View My Cases</Typography>
                </MenuItem>
                <MenuItem key="Request New Case" onClick={handleNewCaseNavMenu}>
                  <CreateNewFolderIcon style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                  <Typography textAlign="center">Request New Case</Typography>
                </MenuItem>
                <MenuItem key="Request to View" onClick={handleRequestViewNavMenu}>
                  <Pageview style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                  <Typography textAlign="center">Request to View</Typography>
                </MenuItem>
                {false && (
                  <MenuItem key="Upload File">
                    <DriveFolderUploadRounded style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                    <Typography textAlign="center">Upload File</Typography>
                  </MenuItem>
                )}
              </Menu>
            </Box>
            <Dialog
              open={showDialog}
              onClose={handleCancel}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description">
              <DialogTitle id="alert-dialog-title">{'Save data?'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  You are about to leave the form and the form contain unsaved data. Do you want to
                  save?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCancel}>No</Button>
                <Button
                  onClick={() => {
                    // reset flag
                    dispatch(caseActions.setDataUpdated(false));
                    setShowDialog(false);
                    if (basicInfo) dispatch(caseActions.setSaveBasicInfo(true));
                    else if (contactInfo) dispatch(caseActions.setSaveContactInfo(true));
                    else if (referringmdInfo) dispatch(caseActions.setSaveMDInfo(true));
                    else if (additionalInfo) dispatch(caseActions.setSaveAdditionalInfo(true));
                  }}
                  autoFocus>
                  Yes
                </Button>
              </DialogActions>
            </Dialog>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex', lg: 'none' } }}>
              <BCHLogoSOP />
            </Typography>
            <Box
              sx={{ flexGrow: 1, display: { xs: 'none', md: 'none', lg: 'flex' }, gap: 4, ml: 3 }}>
              <Button
                key="View My Cases"
                onClick={handleViewCasesNavMenu}
                size="iconSizeLarge"
                startIcon={<BadgeIcon />}
                sx={{ my: 2, color: 'white' }}>
                View My Cases
              </Button>
              <Button
                key="Request New Case"
                size="iconSizeLarge"
                onClick={handleNewCaseNavMenu}
                startIcon={<CreateNewFolderIcon />}
                sx={{ my: 0, color: 'white' }}>
                Request New Case
              </Button>
              <Button
                key="Request to View"
                size="iconSizeLarge"
                onClick={handleRequestViewNavMenu}
                startIcon={<Pageview />}
                sx={{ my: 0, color: 'white' }}>
                Request to View
              </Button>
              {false && (
                <Button
                  key="Upload File"
                  size="iconSizeLarge"
                  onClick={() => setOpenFileUpload(true)}
                  //onClick={handleUploadInfo}
                  startIcon={<DriveFolderUploadRounded />}
                  sx={{ my: 0, color: 'white' }}>
                  Upload File
                </Button>
              )}
              <DropzoneDialog
                acceptedFiles={[
                  'image/*, application/pdf, .rtf, .doc, .docx, .txt, .xls, .xlsx, .xml, .tif, .tiff,'
                ]}
                cancelButtonText={'cancel'}
                submitButtonText={'submit'}
                maxFileSize={4000000}
                open={openFileUpload}
                onClose={() => setOpenFileUpload(false)}
                onSave={(files) => {
                  console.log('Files:', files);
                  setOpenFileUpload(false);
                }}
                showPreviews={true}
                showFileNamesInPreview={true}
              />
            </Box>
            <Box
              sx={{
                mr: 1,
                flexGrow: 0,
                display: { xs: 'flex', md: 'flex' }
              }}>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                <InputLabel id="case-select-label" sx={{ color: 'white' }}>
                  Select Case
                </InputLabel>
                <Select
                  labelId="case-select-label"
                  id="case-select"
                  label="Select Case"
                  value={currentcaseId}
                  sx={{
                    ':before': { color: 'white', borderBottomColor: 'white' },
                    ':after': { borderBottomColor: 'white' },
                    '&:not(.Mui-disabled):hover::before': { borderColor: 'white' },
                    icon: { fill: 'white', color: 'white' }
                  }}
                  onChange={handleCaseChange}
                  inputProps={{
                    sx: {
                      fontSize: 18,
                      mr: 1,
                      color: 'white',
                      icon: { fill: 'white' },
                      borderBottomColor: '2px solid white',
                      '&:after': {
                        borderBottomColor: '2px solid white'
                      }
                    }
                  }}>
                  {st.cases != null &&
                    st.cases !== undefined &&
                    st.cases.length > 0 &&
                    st.cases.map((res) => (
                      <MenuItem key={res.caseId} value={res.caseId}>
                        {res.patientFirstName} {res.patientLastName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Click to open menu">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <AccountCircle style={{ fill: '#FFFFFF' }} sx={{ fontSize: 50 }} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}>
                <MenuItem key="Profile" onClick={handleProfileNavMenu}>
                  <Typography textAlign="center">Profile</Typography>
                </MenuItem>
                <MenuItem key="Logout" onClick={handleLogoutNavMenu}>
                  <Typography textAlign="center">Logout</Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Grid container component="main" sx={styles.containerStyle}>
        {st.cases != null && st.cases !== undefined && st.cases.length === 0 && (
          <Grid item xs={12} sm={12} md={12}>
            <Box
              sx={{
                height: '93vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
              <HeartLogo fontSize={50} />
              <Typography
                style={{
                  fontWeight: '500',
                  fontSize: 32
                }}>
                You don&apos;t have any cases yet
              </Typography> 
              <Box sx={{ mb: 2, ml: 2, mt: 1,  
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 0,
                        mt: 0,
                        width: 450
                        }}> 
                <FormControl>
                  <FormLabel id="demo-controlled-radio-buttons-group"></FormLabel>
                  <RadioGroup
                    aria-labelledby="selection"
                    name="selection"
                    value={selection}
                    onChange={handleSelectionChange}>
                    <Box key={0}  sx={{ my: 3, width: 450, border: 0 }}>
                      <FormControlLabel
                        value={0}
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              fontWeight: '300',
                              fontSize: 20,
                              textAlign: 'left'
                            }}>
                            Create a new case and share your story to get connected with a case coordinator
                            quickly and securely.
                          </Typography>
                        }
                      />
                    </Box>
                    <Box>
                      <FormControlLabel
                        value={1}
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              fontWeight: '300',
                              fontSize: 20,
                              textAlign: 'left'
                            }}>
                            Request to view a case. If the patient you request second opinion for has already a case with us, the case
                            coordinator will be notified. Once the case is reviewed, it will be added here.
                          </Typography>
                        }
                      />
                    </Box>
                  </RadioGroup>
                </FormControl>
              </Box>
              <Button
                variant="contained"
                color="primary"
                sx={styles.formCardButtonStyle}
                onClick={() => {
                  if (selection === '0') {
                    dispatch(caseActions.setShowWelcome(false));
                    dispatch(caseActions.clearCase());
                    dispatch(caseActions.setShowWelcome(false));
                    navigate('/sop2web/newcase');
                  }
                  if (selection === '1') {
                    navigate('/sop2web/requestview');
                  }
                }}>
                  {selection === '0' && <Typography>Create a Case</Typography>}
                {selection === '1'&& <Typography>Request to View a Case</Typography>}
              </Button>
            </Box>
          </Grid>
        )}
        {st.cases != null && st.cases !== undefined && st.cases.length > 0 && (
          <Grid item xs={12} sm={12} md={12}>
            <Grid item xs={12} ms={12} md={12} lg={12} sx={styles.contentStyle}>
              <Divider orientation="vertical" flexItem></Divider>
              <Box sx={styles.leftFormCardContainerStyle}>
                <Container>
                  <Stack>
                    <Box sx={{ maxWidth: 343 }}>
                      <Box sx={{ mt: 3 }}>
                        <Box sx={{ mt: 3, padding: 1, backgroundColor: '#EDF3FC', boxShadow: 1 }}>
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '800',
                              fontSize: 16,
                              mt: 3,
                              textAlign: 'center'
                            }}>
                            Case Status: {getStatusTitle()}
                          </Typography>
                          <Box
                            sx={{
                              mx: 1,
                              mt: 2
                              // mb: 3
                            }}>
                            <Typography
                              style={{
                                color: '#021D4E',
                                fontWeight: '500',
                                fontSize: 14
                              }}>
                              {getStatusText()}
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ my: 3 }}>
                          <Stepper activeStep={getStepIndex()} orientation="vertical">
                            {steps.map((step, index) => {
                              return (
                                <Step key={step} active={index === 2 || index == getStepIndex()}>
                                  <StepLabel>
                                    {(index === 0 || index === 2) && (
                                      <Box
                                        sx={{
                                          backgroundColor: '#FFFFFF'
                                        }}>
                                        <Button>
                                          {index === 0 && (
                                            <Tooltip title="View/Edit case info">
                                              <Typography
                                                style={styles.stepLabelLinkStyle}
                                                onClick={handleGetStarted}>
                                                {step}
                                              </Typography>
                                            </Tooltip>
                                          )}
                                          {index === 2 && (
                                            <Tooltip title="View/Edit more details">
                                              <Typography
                                                style={styles.stepLabelLinkStyle}
                                                onClick={handleContact}>
                                                {step}
                                              </Typography>
                                            </Tooltip>
                                          )}
                                        </Button>
                                      </Box>
                                    )}
                                    {index === 4 && (
                                      <Box
                                        //onClick={() => setOpenFileUpload(true)}
                                        //onClick={handleUploadInfo}
                                        sx={{
                                          //backgroundColor: '#F2F5F9',
                                          display: 'flex',
                                          flexDirection: 'row',
                                          alignItems: 'center',
                                          justifyContent: 'space-between'
                                        }}>
                                       <Typography style={styles.stepLabelStyle}>
                                          {step}
                                        </Typography>
                                      </Box>
                                    )}
                                    {index !== 0 && index !== 2 && index !== 4 && (
                                      <Typography style={styles.stepLabelStyle}>{step}</Typography>
                                    )}
                                  </StepLabel>
                                  <StepContent>
                                    {index === 2 && (
                                      <Box
                                        sx={{
                                          flexDirection: 'column',
                                          backgroundColor: '#F2F5F9'
                                        }}>
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                          }}
                                          onClick={handleContact}>
                                          <Tooltip title="View/Edit contact info">
                                            <Button>
                                              <Typography style={styles.stepLabelLinkStyle}>
                                                How can we reach you?
                                              </Typography>
                                            </Button>
                                          </Tooltip>
                                          {currentcase !== null &&
                                            currentcase.complete !== undefined &&
                                            currentcase.complete.length !== undefined &&
                                            currentcase.complete.length === 3 &&
                                            String(currentcase.complete).substring(
                                              currentcase.complete.length - 3,
                                              currentcase.complete.length - 2
                                            ) === '1' && (
                                              <AssignmentTurnedInIcon
                                                color="primary"
                                                style={{ fontSize: 20 }}
                                              />
                                            )}
                                          {!(
                                            currentcase !== null &&
                                            currentcase.complete !== undefined &&
                                            currentcase.complete.length === 3 &&
                                            String(currentcase.complete).substring(
                                              currentcase.complete.length - 3,
                                              currentcase.complete.length - 2
                                            ) === '1'
                                          ) && (
                                            <ContentPasteIcon
                                              color="primary"
                                              style={{ fontSize: 20 }}
                                            />
                                          )}
                                        </Box>
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                          }}>
                                          <Tooltip title="View/Edit referring MD info">
                                            <Button>
                                              <Typography
                                                style={styles.stepLabelLinkStyle}
                                                onClick={handleReferMD}>
                                                Referring MD info
                                              </Typography>
                                            </Button>
                                          </Tooltip>
                                          {currentcase !== null &&
                                            currentcase.complete !== undefined &&
                                            currentcase.complete.length !== undefined &&
                                            currentcase.complete.length === 3 &&
                                            String(currentcase.complete).substring(
                                              currentcase.complete.length - 2,
                                              currentcase.complete.length - 1
                                            ) === '1' && (
                                              <AssignmentTurnedInIcon
                                                color="primary"
                                                style={{ fontSize: 20 }}
                                              />
                                            )}
                                          {!(
                                            currentcase !== null &&
                                            currentcase.complete !== undefined &&
                                            currentcase.complete.length === 3 &&
                                            String(currentcase.complete).substring(
                                              currentcase.complete.length - 2,
                                              currentcase.complete.length - 1
                                            ) === '1'
                                          ) && (
                                            <ContentPasteIcon
                                              color="primary"
                                              style={{ fontSize: 20 }}
                                            />
                                          )}
                                        </Box>
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                          }}>
                                          <Tooltip title="View/Edit additional requests">
                                            <Button>
                                              <Typography
                                                style={styles.stepLabelLinkStyle}
                                                onClick={handleAdditionalInfo}>
                                                Additional requests
                                              </Typography>
                                            </Button>
                                          </Tooltip>
                                          {currentcase !== null &&
                                            currentcase.complete !== undefined &&
                                            currentcase.complete.length !== undefined &&
                                            currentcase.complete.length === 3 &&
                                            String(currentcase.complete).substring(
                                              currentcase.complete.length - 1,
                                              currentcase.complete.length
                                            ) === '1' && (
                                              <AssignmentTurnedInIcon
                                                color="primary"
                                                style={{ fontSize: 20 }}
                                              />
                                            )}
                                          {!(
                                            currentcase !== null &&
                                            currentcase.complete !== undefined &&
                                            currentcase.complete.length === 3 &&
                                            String(currentcase.complete).substring(
                                              currentcase.complete.length - 1,
                                              currentcase.complete.length
                                            ) === '1'
                                          ) && (
                                            <ContentPasteIcon
                                              color="primary"
                                              style={{ fontSize: 20 }}
                                            />
                                          )}
                                        </Box>
                                        {false && (
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              flexDirection: 'row',
                                              alignItems: 'center',
                                              justifyContent: 'space-between'
                                            }}>
                                            <Tooltip title="View/Edit parent/guardian information">
                                              <Button>
                                                <Typography
                                                  style={styles.stepLabelLinkStyle}
                                                  onClick={handleGuardianInfo}>
                                                  Parent/Guardian Information
                                                </Typography>
                                              </Button>
                                            </Tooltip>
                                            {currentcase !== null &&
                                              currentcase.complete !== undefined &&
                                              currentcase.complete.length !== undefined &&
                                              currentcase.complete.length === 4 &&
                                              String(currentcase.complete).substring(
                                                currentcase.complete.length - 1,
                                                currentcase.complete.length
                                              ) === '1' && (
                                                <AssignmentTurnedInIcon
                                                  color="primary"
                                                  style={{ fontSize: 20 }}
                                                />
                                              )}
                                            {!(
                                              currentcase !== null &&
                                              currentcase.complete !== undefined &&
                                              currentcase.complete.length === 4 &&
                                              String(currentcase.complete).substring(
                                                currentcase.complete.length - 1,
                                                currentcase.complete.length
                                              ) === '1'
                                            ) && (
                                              <ContentPasteIcon
                                                color="primary"
                                                style={{ fontSize: 20 }}
                                              />
                                            )}
                                          </Box>
                                        )}
                                        {false && (
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              flexDirection: 'row',
                                              alignItems: 'center',
                                              justifyContent: 'space-between'
                                            }}>
                                            <Typography
                                              style={styles.stepLabelLinkStyle}
                                              //onClick={handleInsuranceInfo}
                                            >
                                              Guarantor and Insurance
                                            </Typography>
                                          </Box>
                                        )}
                                      </Box>
                                    )}
                                  </StepContent>
                                </Step>
                              );
                            })}
                          </Stepper>
                        </Box>
                      </Box>
                    </Box>
                  </Stack>
                </Container>
              </Box>
              <Divider orientation="vertical" flexItem></Divider>
              <Box sx={styles.rightFormCardContainerStyle}>
                {st.viewSummary && <Summary />}
                {basicInfo && <GetStarted setSummaryView={setSummaryView} />}
                {contactInfo && <ContactInfo setSummaryView={setSummaryView} />}
                {referringmdInfo && <ReferringMD setSummaryView={setSummaryView} />}
                {additionalInfo && <AdditionalInfo setSummaryView={setSummaryView} />}
                {guardianInfo && <GuardianInfo setSummaryView={setSummaryView} />}
                {insuranceInfo && <InsuranceInfo setSummaryView={setSummaryView} />}
                {uploadInfo && <FileUpload setSummaryView={setSummaryView} />}
              </Box>
              <Divider orientation="vertical" flexItem></Divider>
            </Grid>
          </Grid>
        )}
      </Grid>
      <Footer />
    </ThemeProvider>
  );
}
